import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";
import theme from "@/foundation/Theme";

export const ButtonWrapper = styled(FlexDiv)`
  flex: 1;
`;

export const StyledButton = styled(Button)`
  background-color: ${theme.colorsV2.shyft.purple_text};
  box-shadow: ${`0px 10px 20px rgba(${theme.colors.shadows.purple_3}, 0.18), 0px 2px 6px rgba(${theme.colors.shadows.purple_3}, 0.12), 0px 0px 1px rgba(${theme.colors.shadows.black}, 0.04)`};
  font-size: 16px;
  line-height: 24px;
  font-family: var(--man-700);
  padding: 16px 40px;
  min-width: 145px;
  min-height: 56px;

  @media only screen and (max-width: 600px) {
    padding: unset;
  }

  @media only screen and (max-width: 400px) {
    padding: unset;
    min-width: 100px;
    min-height: 45px;
  }
`;
